// components/DeleteConfirmationModal.tsx
import React from "react";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  resolve?: boolean;
}

const CommentDeletionConfirmationModal: React.FC<
  DeleteConfirmationModalProps
> = ({ isOpen, onClose, onConfirm, resolve }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      {!resolve ? (
        <div className="bg-white p-6 rounded-lg shadow-lg w-80">
          <h2 className="text-lg font-semibold">Confirm Deletion</h2>
          <p className="text-gray-600 text-sm mt-2">
            Are you sure you want to delete this comment?
          </p>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              className="px-4 py-2 text-sm bg-gray-300 rounded-lg hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700"
              onClick={onConfirm}
            >
              Delete
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-white p-6 rounded-lg shadow-lg w-80">
          <h2 className="text-lg font-semibold">Confirm Resolve</h2>
          <p className="text-gray-600 text-sm mt-2">
            Are you sure you want to resolve this comment?
          </p>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              className="px-4 py-2 text-sm bg-gray-300 rounded-lg hover:bg-gray-400"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-700"
              onClick={onConfirm}
            >
              Resolve
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentDeletionConfirmationModal;
